
export const chartsPopOption = {
    dataZoom: [
        // {
        //     type: "inside",
        //     start: 0, //数据窗口范围的起始百分比,表示1%
        //     end: 100, //数据窗口范围的结束百分比,表示35%坐标
        // },
        // {
        //     type: "slider",
        //     height: 15,
        //     bottom: 0,
        //     brushSelect: false,
        //     showDetail: false,
        //     showDataShadow: false,
        // },
    ],
    title: {
        text: "",
    },
    tooltip: {
        trigger: "axis"
    },
    legend: {
        data: ['支付数量'],
    },
    grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
    },
    toolbox: {
        feature: {
            saveAsImage: {},
        },
    },
    xAxis: {
        type: "category",
        boundaryGap: false,
        data: [], // x轴日期数组
    },
    yAxis: [{
            type: 'value',
            name: '数量',
            minInterval: 1,
            axisLabel: {
                formatter: '{value}'
            }
        }
    ],
    series: [{
            name: "支付数量",
            type: "line",
            data: [], // 成交单数数组
            itemStyle: {
                color: 'rgb(217,2,27)'
            }
        },
        // {
        //     name: "退款单数",
        //     type: "line",
        //     // data: [], // 退款单数
        //     data: [220, 182, 191, 234, 290, 330, 310,220, 182, 191, 234, 290, 330, 310,220, 182, 191, 234, 290, 330, 310], // 退款单数
        //     itemStyle: {
        //         color: 'rgb(2,167,240)'
        //     }
        // },
        // {
        //     name: "总单数",
        //     type: "line",
        //     data: [150, 232, 201, 154, 190, 330, 410,150, 232, 201, 154, 190, 330, 410,150, 232, 201, 154, 190, 330, 410], // 总单数
        //     // data: [], // 总单数
        //     itemStyle: {
        //         color: 'rgb(112,182,3)'
        //     }
        // }
    ]
}